module.exports = __webpack_public_path__ + "static/img/IMG_20150610_223751.60260852.jpg";